import React from 'react'
import { CollectionTable } from '..'

const Editions = props => (
  <CollectionTable type="edition" history={props.history} />
)

export default Editions
